import EditorFeatureTitle from "../../components/editor/EditorFeatureTitle"
import EditorFeatureSubtitle from "../../components/editor/EditorFeatureSubtitle"

const Pacing = () => {
	return (
		<div className='bg-white shadow-sm lg:p-9 xl:p-9 2xl:p-10'>
			<EditorFeatureTitle title='Pacing' />
			<EditorFeatureSubtitle>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit
			</EditorFeatureSubtitle>
			<div className='lg:space-y-4  2xl:space-y-5 lg:mt-7 xl:mt-8 2xl:mt-9'>
				<div className='flex lg:py-4 2xl:py-5 lg:px-5 2xl:px-6 rounded-lg border border-db items-center space-x-4'>
					<div className='w-9 h-9 rounded-md border-2 border-aaa bg-e5'></div>
					<div className='text-xl font-bold text-1b'>Fiverr was</div>
				</div>
			</div>
		</div>
	)
}

export default Pacing